import { action } from 'mobx';
import { ScheduledJobLogService } from 'common/data';
import _ from 'lodash';
import { BaseStore } from 'core/stores';

class ScheduledJobLogStore extends BaseStore {
	constructor(rootStore) {
		super(new ScheduledJobLogService(rootStore.app.baasic.apiClient));
	}

	@action
	findScheduledJobLogs = async filter => {
		const response = await this.service.findScheduledJobLogs(filter);
		response.data.searchQuery = filter.search;
		this.response = response.data;
	};
}

export default ScheduledJobLogStore;
